import BaseStore from 'src/stores/base/baseStore';
import entityTypes from 'src/types/entityTypes';
import { observable, action, runInAction, computed } from 'mobx';
import entityApi from 'src/apis/entityApi';
import { Stores } from "src/stores";
import ContentAuditStore from '../repeatAuditStore'
import { playerUtil } from 'mam-common-utils';
import { message } from 'antd';
import _ from 'lodash';
import contentMgApi from 'src/apis/contentMgApi';

export default class ReviewInfoStore extends BaseStore<Stores> {
    public parentStore: ContentAuditStore;
    // 审片信息数据
    @observable
    public reviewInfo: entityTypes.IReviewReuslt[] = []
    /** 秒 */
    @observable
    public playerCurrentTime: number = 0
    @observable
    public descGroups: entityTypes.IDescGroup[] = []
    @observable
    public selectedFilter: string[] = []
    @observable
    public reivewInfoColors: entityTypes.IReivewInfoColorRes[] = []
    @observable
    public isLoadingReviewData = false;
    private isAddedListener: boolean

    public constructor(stores: Stores, parentStore: ContentAuditStore) {
        super(stores)
        this.parentStore = parentStore;
    }

    @action
    public getReviewData(contentId: string) {
        return new Promise((resolve, reject)=>{
            this.isLoadingReviewData = true;
            entityApi.getReivewResult(contentId).then(res => {
                runInAction(() => {
                    if (res.data.data) {
                        res.data.data.forEach((s)=>{
                            let group = this.descGroups.find(f => f.value === s.description);
                            if (!group) {
                                group = {
                                    value: s.description,
                                    label: s.description
                                }
                                this.descGroups.push(group)
                            }
                        })
                        this.reviewInfo = res.data.data;
                        this.selectedFilter = this.descGroups.map(s => s.value);
                        this.isLoadingReviewData = false;
                        //获取重复信息
                        // if(this.parentStore.entityStore.entity && (this.parentStore.entityStore.entity.type === "video" ||this.parentStore.entityStore.entity.type === "audio" || this.parentStore.entityStore.entity.type === "biz_sobey_video" ||this.parentStore.entityStore.entity.type === "biz_sobey_audio")){
                        //     this.getRepeatResult(contentId)
                        // }
                        resolve(true);
                    }
                })
            }, res=>{
                if (res.data.error && res.data.error.title){
                    message.error(res.data.error.title);
                }
                reject();
            });
        })
    }
    @action
    public getRepeatResult(contentId: string) {
        return new Promise((resolve, reject)=>{
            contentMgApi.repeatAuditApi.getRepeatResult(contentId).then(res => {
                runInAction(() => {
                    if (res.data.success) {
                        if(res.data.data && res.data.data.confidence){
                            //将重复的结果和审核结果reviewInfo进行合并
                            if(!this.descGroups.find(f => f.value === "重复")){
                                this.descGroups.unshift({
                                    value: "重复",
                                    label: "重复",
                                })
                            }
                            this.reviewInfo.unshift({
                                analysisType: "repeat",
                                begin: 0,
                                description: "重复",
                                end: 0,
                                inPoint: 0,
                                metadataType: "",
                                outPoint: !this.parentStore.entityStore.loadError && this.parentStore.entityStore.entity?.duration ? this.parentStore.entityStore.entity.duration : 0,
                                scenes: "重复",
                                label: res.data.data.confidence,
                                silentTracks: [],
                            })
                            this.selectedFilter.unshift("重复")
                        }
                        resolve(true);
                    }
                })
            }, res=>{
                if (res.data.error && res.data.error.title){
                    message.error(res.data.error.title);
                }
                reject();
            });
        })
    }

    @action
    public changeFilter(checkedValues: string[]) {
        this.selectedFilter = checkedValues
    }

    @action
    public getReviewInfoColor(){
        entityApi.getReivewInfoColor().then(res=>{
            runInAction(()=>{
                if (res.data.data){
                    //增加重复类型的颜色
                    if(!_.find(res.data.data, {key: "重复"})){
                        res.data.data.push({
                            key: "重复",
                            color: "#F00300"
                        })
                    }
                    this.reivewInfoColors = res.data.data;
                    
                }
            })
        }, res=>{
            if (res.data.error && res.data.error.title){
                message.error(res.data.error.title);
            }
        })
    }

    public getAnalysisTypeByCode(code: string){
        switch(code){
            case 'frame':
                return '画面';
            case 'ocr':
                return '字幕';
            case 'asr':
                return '语音';
            case 'tech':
                return '技术';
            default : return '';
        }
    }

    public watchPlayer() {
        if (!this.isAddedListener && this.parentStore.entityStore.viewer && this.parentStore.entityStore.viewer.player) {
            this.isAddedListener = true
            this.parentStore.entityStore.viewer.player.media.addEventListener('accurateTimeUpdate', (res: any) => {
                runInAction(() => {
                    this.playerCurrentTime = this.parentStore.entityStore.viewer.player.getCurrentTime()
                })
            })
        }
    }

    private getL100Ns(obj: any, l100NsKey: string, frameKey: string) {
        // 是否返回百纳秒
        if (obj[l100NsKey] === -1) {
            // 没有返回则取帧号 转换为百纳秒
            if (obj[frameKey] !== null && obj[frameKey] !== undefined && obj[frameKey] > -1) {
                return playerUtil.frame2L100Ns(obj[frameKey], this.parentStore.entityStore.frameRate);
            } else {
                return 0;
            }
        } else {
            return obj[l100NsKey]
        }
    }
}   
